import Client from './client';

export default class ManualReviewRules extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/fraud/manual/rules`, options);
  }

  getByResponsibleParty(organization, responsibleParty, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/fraud/manual/rules/${responsibleParty}`, options);
  }

  putByResponsibleParty(organization, responsibleParty, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/fraud/manual/rules/${responsibleParty}`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteByResponsibleParty(organization, responsibleParty, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/fraud/manual/rules/${responsibleParty}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
